import { MockFactory } from '@tino-frontend/mocks'
import { BillListResponseV3, BillStatus } from '@types'

import { allLineItemsMock } from '@fixtures/apis/bill/line-item/all-line-items'
import { billBaseMock } from '@fixtures/apis/bill/detail-v3/bill-base'
import { allLineItemsGroupMock } from '@fixtures/apis/bill/line-item/all-line-items-group'
import { lineItemInstallment } from '@fixtures/apis/bill/line-item/installment'

// Bill
const bill0 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-separated',
    status: BillStatus.Overdue,
    line_item_groups: allLineItemsMock.source,
  },
  { mergeArray: false }
)
const bill1 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-group',
    status: BillStatus.Open,
    line_item_groups: allLineItemsGroupMock.source,
  },
  { mergeArray: false }
)
const bill2 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-group-with-no-group',
    status: BillStatus.Open,
    line_item_groups: [
      {
        line_items: [lineItemInstallment.build()],
        is_paid: false,
      },
      {
        line_items: [
          lineItemInstallment.build(
            {
              ...lineItemInstallment.source,
              metadata: {
                ...lineItemInstallment.source.metadata,
                invoice_approved_at: '2023-12-02T00:00:00Z',
                installment_id: 'invoice_installments_id_2',
              },
            },
            { mergeObject: false }
          ),
        ],
        is_paid: false,
      },
      ...allLineItemsGroupMock.source,
    ],
  },
  { mergeArray: false }
)
const bill3 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-group-current',
    status: BillStatus.Open,
    line_item_groups: allLineItemsGroupMock.source,
  },
  { mergeArray: false }
)

export const billListLineItemsGroupMock = new MockFactory<BillListResponseV3>({
  current_bill_id: 'bill-group-current',
  bills: [bill0, bill1, bill2, bill3],
})
